// Tells Sage which lesson or video this page shows (on-screen-material.ts), so
// "example 3" or "this video" means something without the student pasting it.
// Clears on unmount. Renders nothing.

'use client'

import { useEffect } from 'react'
import { setOnScreenMaterial, type LessonRef, type VideoRef } from '@/lib/tutor/on-screen-material'

export default function PublishOnScreenMaterial({
  lesson,
  video,
  label,
}: {
  lesson?: LessonRef
  video?: VideoRef
  label: string
}) {
  const lessonSlug = lesson?.slug
  const videoCollection = video?.collection
  const videoSlug = video?.slug
  useEffect(() => {
    setOnScreenMaterial({
      ...(lessonSlug ? { lesson: { slug: lessonSlug } } : {}),
      ...(videoCollection && videoSlug
        ? { video: { collection: videoCollection, slug: videoSlug } }
        : {}),
      label,
    })
    return () =>
      setOnScreenMaterial({
        ...(lessonSlug ? { lesson: null } : {}),
        ...(videoSlug ? { video: null } : {}),
        label: null,
      })
  }, [lessonSlug, videoCollection, videoSlug, label])
  return null
}
